import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { useCallback } from 'react';
// biome-ignore lint/style/noRestrictedImports: using react-use for clipboard handling
import { useCopyToClipboard as useBaseCopyToClipboard } from 'react-use';

type UseCopyToClipboardOptions = {
  suppressSnackbar?: boolean;
};

const useCopyToClipboard = (options?: UseCopyToClipboardOptions) => {
  const { showSnackbar } = useSnackbar();
  const [copyClipboardState, copyToClipboard] = useBaseCopyToClipboard();
  const { t } = useTranslation();

  const { suppressSnackbar = false } = options ?? {};

  const handleCopy = useCallback(
    (text: string) => {
      copyToClipboard(text);
      if (copyClipboardState.error) {
        console.error('Error copying to clipboard:', copyClipboardState.error);
        if (!suppressSnackbar) {
          showSnackbar({ color: 'error', title: t('common:ClipboardCopy.error') });
        }
      } else if (!suppressSnackbar) {
        showSnackbar({ color: 'success', title: t('common:ClipboardCopy.success') });
      }
    },
    [copyClipboardState.error, copyToClipboard, showSnackbar, suppressSnackbar, t],
  );

  return { handleCopy };
};

export default useCopyToClipboard;
